import { render, staticRenderFns } from "./SliderManagement.vue?vue&type=template&id=0843f288"
import script from "./SliderManagement.vue?vue&type=script&lang=js"
export * from "./SliderManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports